<template>
  <div class="memberCenter">
     <div class="navBox">
        <div class="flexRow">
          <div class="navLeft flexRow">
            <router-link class="backIndex" tag="div" to="/">
              <i class="iconfont icon-iconset0276"></i>
              <span class="vert">天算</span>
            </router-link>
            <div>·</div>
            <div>会员中心</div>
          </div>
          <div class="navCenter">
            <ul class="flexRow">
              <router-link tag="li" to="/memberCenterIndex/knowledgeFootprint">知识足迹</router-link>
              <router-link tag="li" to="/memberCenterIndex/messageReminder">消息提醒</router-link>
<!--              <router-link tag="li" to="/memberCenterIndex/KnowledgeOrder">知识订单</router-link>-->
              <router-link tag="li" to="/memberCenterIndex/personalInformation">个人信息</router-link>
              <!-- <router-link tag="li" to="/accountInformation">账户信息</router-link> -->
            </ul>
          </div>
          <div class="navRight flexRow">
            <login-area ></login-area>
          </div>
        </div>
     </div>
     <router-view></router-view>
  </div>
</template>

<script>
  import store from '@/store'
  import loginArea from '@/components/loginArea'
  export default({
    name:'memberCenterIndex',
    components: {
      loginArea
    },
    data(){
      return{
        //username:store.state.name?store.state.name:sessionStorage.getItem('user')
        username:'测试测试'
      }
    }
  })
</script>

<style lang="scss" scoped>
  .navBox{background: #252B3A;}
  .navBox>div{width: 1280px;margin: 0 auto;color: #BEBEBE;padding: 15px;}
  .flexRow{display: flex;flex-direction: row;align-items: center;}
  .navLeft{font-size: 24px;}
  .navLeft>div{margin: 0 5px;}
  .navCenter{padding: 0 20px;flex: 1;margin-left: 30px;}
  .icon-iconset0276{font-size: 24px;vertical-align: 0;}
  .navCenter li{padding: 15px 20px;}
  .user {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0 15px 0px 20px;
  }
  .nameBox{margin-left: 5px;}
  .nameBox:hover{cursor: pointer;color: $color-primary;}
  .icon-xiaoxi2{font-size: 24px;vertical-align: 0;}
  .icon-xiaoxi2:hover{color: $color-primary;cursor: pointer;}
  >>>.el-badge__content{border-color: $color-primary;}
  .user img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .navCenter>>>.router-link-active{color: #fff;}
  .navCenter li:hover{color: #fff;cursor: pointer;}
  .backIndex:hover{color: #fff;cursor: pointer;}
</style>



// WEBPACK FOOTER //
// src/page/memberCenter/memberCenterIndex.vue